import { makeStyles } from '@mui/styles';

import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    backgroundColor: theme.palette.whitePepper.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowX: 'auto',
    columnGap: '40px',
    padding: '20px 25px 0',

    [theme.breakpoints.up('sm')]: {
      padding: '40px 25px 0',
      columnGap: '120px',
    },
  },

  title: {
    flexShrink: 0,
    cursor: 'pointer',
    minWidth: '80px',
  },
});
